import React from 'react';
import { GlassGradient, GlassPanel, Handle, BattenteTriangleFill, AntaRibaltaFill, VasistasFill, FixedMark, SlidingArrow, BilicoH, BilicoV } from './primitives';

export const garageDoor = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_gd" />
    <rect x={8} y={8} width={104} height={84} fill="#D8D8D8" stroke="#333" strokeWidth="1" />
    <line x1={8} y1={28} x2={112} y2={28} stroke="#999" strokeWidth="0.8" />
    <line x1={8} y1={48} x2={112} y2={48} stroke="#999" strokeWidth="0.8" />
    <line x1={8} y1={68} x2={112} y2={68} stroke="#999" strokeWidth="0.8" />
    <GlassPanel x={18} y={12} w={22} h={12} gradId="g_gd" />
    <GlassPanel x={49} y={12} w={22} h={12} gradId="g_gd" />
    <GlassPanel x={80} y={12} w={22} h={12} gradId="g_gd" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const rollerShutter = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <rect x={8} y={4} width={64} height={12} fill="#A0A0A0" stroke="#333" strokeWidth="1" rx="2" />
    {[0,1,2,3,4,5,6,7,8,9].map(i => (
      <rect key={i} x={10} y={18+i*8} width={60} height={6} fill={i%2===0?'#C8C8C8':'#B8B8B8'} stroke="#999" strokeWidth="0.5" rx="1" />
    ))}
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const cassonetto = () => (
  <svg viewBox="0 0 90 100" className="w-full h-full">
    {/* Cassonetto box */}
    <rect x={8} y={8} width={74} height={28} fill="#B0B0B0" stroke="#333" strokeWidth="1.5" rx="3" />
    <line x1={14} y1={22} x2={76} y2={22} stroke="#999" strokeWidth="0.8" />
    {/* Sportello ispezione */}
    <rect x={32} y={12} width={26} height={18} fill="#A0A0A0" stroke="#666" strokeWidth="0.8" rx="1" />
    <circle cx={45} cy={21} r={2} fill="#666" />
    {/* Guida laterale SX */}
    <rect x={10} y={36} width={4} height={52} fill="#C0C0C0" stroke="#999" strokeWidth="0.5" />
    {/* Guida laterale DX */}
    <rect x={76} y={36} width={4} height={52} fill="#C0C0C0" stroke="#999" strokeWidth="0.5" />
    {/* Tapparella arrotolata dentro cassonetto */}
    <ellipse cx={45} cy={22} rx={10} ry={8} fill="none" stroke="#888" strokeWidth="0.6" strokeDasharray="2,1.5" />
    <rect x={4} y={4} width={82} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const monoblocco = () => (
  <svg viewBox="0 0 90 100" className="w-full h-full">
    {/* Struttura monoblocco - box integrato con vano tapparella */}
    <rect x={8} y={6} width={74} height={88} fill="#E8E0D0" stroke="#333" strokeWidth="1.5" />
    {/* Vano cassonetto superiore */}
    <rect x={12} y={10} width={66} height={22} fill="#C8C0B0" stroke="#666" strokeWidth="0.8" />
    {/* Rullo tapparella */}
    <ellipse cx={45} cy={21} rx={8} ry={6} fill="none" stroke="#888" strokeWidth="0.8" />
    {/* Guida laterale SX */}
    <rect x={12} y={32} width={6} height={58} fill="#D0C8B8" stroke="#999" strokeWidth="0.5" />
    {/* Guida laterale DX */}
    <rect x={72} y={32} width={6} height={58} fill="#D0C8B8" stroke="#999" strokeWidth="0.5" />
    {/* Vano serramento centrale */}
    <GlassGradient id="g_mb" />
    <GlassPanel x={20} y={34} w={50} h={54} gradId="g_mb" />
    <rect x={4} y={4} width={82} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

export const controtelaio = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    {/* Telaio esterno (controtelaio) */}
    <rect x={8} y={6} width={64} height={88} fill="none" stroke="#333" strokeWidth="3" />
    {/* Profilo superiore */}
    <rect x={8} y={6} width={64} height={6} fill="#A0A0A0" stroke="#666" strokeWidth="0.5" />
    {/* Profilo inferiore */}
    <rect x={8} y={88} width={64} height={6} fill="#A0A0A0" stroke="#666" strokeWidth="0.5" />
    {/* Profilo laterale SX */}
    <rect x={8} y={6} width={6} height={88} fill="#A0A0A0" stroke="#666" strokeWidth="0.5" />
    {/* Profilo laterale DX */}
    <rect x={66} y={6} width={6} height={88} fill="#A0A0A0" stroke="#666" strokeWidth="0.5" />
    {/* Alette di ancoraggio */}
    <line x1={4} y1={20} x2={8} y2={20} stroke="#666" strokeWidth="1.5" />
    <line x1={4} y1={50} x2={8} y2={50} stroke="#666" strokeWidth="1.5" />
    <line x1={4} y1={80} x2={8} y2={80} stroke="#666" strokeWidth="1.5" />
    <line x1={72} y1={20} x2={76} y2={20} stroke="#666" strokeWidth="1.5" />
    <line x1={72} y1={50} x2={76} y2={50} stroke="#666" strokeWidth="1.5" />
    <line x1={72} y1={80} x2={76} y2={80} stroke="#666" strokeWidth="1.5" />
    {/* Vano vuoto interno */}
    <rect x={16} y={14} width={48} height={72} fill="#F5F5F5" stroke="#CCC" strokeWidth="0.5" strokeDasharray="3,2" />
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

